package app

import kotlinx.serialization.Serializable

@Serializable
data class AppProperties(var apiEndpoint: String = "", var properties: Map<String, String> = emptyMap()) {

}
